/**
 * Lazy Sentry initialisation — the SDK is NEVER bundled into the main chunk.
 *
 * When VITE_SENTRY_DSN is empty the dynamic import below is unreachable, so
 * Vite code-splits @sentry/browser into a separate chunk that the browser
 * never even fetches in that case.
 */
export async function initSentry(): Promise<void> {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  try {
    const Sentry = await import('@sentry/browser');
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      // Errors only — no performance tracing or session replay overhead.
      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
    });
  } catch (err) {
    // A Sentry failure must never break app startup.
    console.warn('[sentry] failed to initialise:', err);
  }
}
